import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const LINE_BREAK_PLUGIN_ID = 'lineBreak' as const;
export type LineBreakPluginID = typeof LINE_BREAK_PLUGIN_ID;

export type LineBreakPluginElement = Readonly<
  EditorElement & {
    type: LineBreakPluginID;
  }
>;

export type LineBreakPluginElementMutable = LineBreakPluginElement;

export type LineBreakPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type LineBreakPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    LineBreakPluginOptions & {
      pluginID: LineBreakPluginID;
      component: ComponentType<any>;
      pluginName: string;
    }
>;
